<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Mietvertrag Management

  section.modal-card-body
    ValidationObserver(ref="form")
      div
        .container2
          .two-column
            .column
              h2.title.is-6 E-Mail Anhang
              iframe(ref="pdf-preview").pdf-preview
            .column(v-if="formData.sendCustomerEmail")
              .form.w640
                h2.title.is-6 Gast E-Mail
                ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Betreff" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.subject")
                ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="formData.body" :editorOptions="editorOptions")
              .spacer.sm
              //- .form.w640
                h2.title.is-6 Optionale Einleitung
                ValidationProvider(name="Optionale Einleitung" rules="" v-slot="{ errors, valid }") 
                  b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.optionalOfferText" type="textarea")
                b-button(type="is-light" @click="generatePDF()") PDF aktualisieren
            .column(v-if="formData.sendOwnerEmail")
              .form.w640
                h2.title.is-6 Eigentümer E-Mail
                ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Betreff" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.subjectOwner")
                ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="formData.bodyOwner" :editorOptions="editorOptions")

      
  footer.modal-card-foot
    .button-wrapper.max.right
      button.button.is-gray(@click="$emit('close')") Abbrechen
      .spacer.lg.inline
      b-checkbox(v-model="formData.sendCustomerEmail") Gast E-Mail senden
      b-checkbox(v-model="formData.sendOwnerEmail") Eigentümer E-Mail senden
    //- button.button.is-secondary(@click="sendContract()") Speichern ohne Senden
    .spacer.lg
    button.button.is-primary(@click="sendContract(formData.sendCustomerEmail ? 'sendEmail' : undefined)") {{formData.sendCustomerEmail || formData.sendOwnerEmail ? 'Senden & Speichern' : 'Speichern'}}
</template>

<script>
import { DateTime } from 'luxon';

export default {
  props: {
    rentObject: {
      type: Object
    },
    booking: {
      type: Object
    },
    bookingInformation: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    updatePreviewMode: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        subject: 'Unser Angebot zu Ihrer Anfrage - '+this.booking.rentObject.name,
        body: null,
        subjectOwner: 'Unser Angebot zu Ihrer Anfrage - '+this.booking.rentObject.name,
        bodyOwner: null,
        optionalOfferText: null,
        sendOwnerEmail: false,
        sendCustomerEmail: true
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  computed: {
    bookingStatus() {
      return this.$store.state.bookingStatus.all
    }
  },
  async mounted() {
    if (this.booking.id && this.updatePreviewMode === false) {
      this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
    } else {
      this.fullBooking = this.booking;
    }
    // Now we check if we want to send a contract
    // for a contract we need the full name and address
    if (!this.fullBooking.customer.firstName || !this.fullBooking.customer.lastName || !this.fullBooking.customer.address.street || !this.fullBooking.customer.address.zip || !this.fullBooking.customer.address.city) {
      let confirmRoute = this.$route.path;
      if (this.$route.name === 'BookingCalendar') {
        confirmRoute = `/booking/${this.booking.id}&showContract=true`;
      }
      this.$buefy.dialog.confirm({
        title: 'Gastdaten sind unvollständig',
        message: 'Damit ein Mietvertrag erstellt werden kann, müssen alle Gastdaten eingegeben werden',
        type: 'is-warning',
        ariaRole: 'alertdialog',
        ariaModal: true,
        cancelText: 'Abbrechen',
        confirmText: 'Gastdaten vervollständigen',
        onConfirm: () => {
          // We temporary save the data
          // as we send the user to another screen
          this.$store.commit('rentObjectBookings/setTemporaryBooking', {booking: this.fullBooking, bookingInformation: this.bookingInformation});
          this.$router.push('/data/customers/edit/'+this.fullBooking.customer.id+'/?from='+ confirmRoute + '&showContract=true');
          }
      })
      this.$emit("close");
    } else {
      // Here everything is fine
      const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
      let contractTemplate = emailTemplates.find(e => e.uuid === 'CONTRACT_EMAIL');
      let contractOwnerTemplate = emailTemplates.find(e => e.uuid === 'CONTRACT_OWNER_EMAIL');

      const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: contractTemplate, booking: {...this.fullBooking, rentObject: this.rentObject ?? this.fullBooking.rentObject, ...this.calcTotalPrices({...this.fullBooking, ...this.bookingInformation?.items})}});
      const resultOwner = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: contractOwnerTemplate, booking: {...this.fullBooking, rentObject: this.rentObject ?? this.fullBooking.rentObject, ...this.calcTotalPrices({...this.fullBooking, ...this.bookingInformation?.items})}});
      this.formData.subject = result.template.subject;
      this.formData.body = result.template.body;
      this.formData.subjectOwner = resultOwner.template.subject;
      this.formData.bodyOwner = resultOwner.template.body;
      this.generatePDF();
    }
  },
  methods: {
    async generatePDF() {
      const loadingComponent = this.$buefy.loading.open();
      
      const pdfArraybuffer = await this.$store.dispatch("rentObjectBookings/contractPDFPreview", {id: this.booking.id && this.updatePreviewMode === false ? this.booking.id : 0, optional: this.formData.optionalOfferText, bookingData: {...this.fullBooking, ...this.bookingInformation?.items}});
      const pdfBlob = new Blob([pdfArraybuffer], { type: "application/pdf" });
      this.$refs["pdf-preview"].src = URL.createObjectURL(pdfBlob);
      
      loadingComponent.close();
    },
    sendContract(sendEmail) {
      let contractId = null;
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        const loadingComponent = this.$buefy.loading.open();
        if (!this.booking.id) {
          // First we create the booking
          const newBooking = await this.$store.dispatch("rentObjectBookings/create", {...this.fullBooking, ...this.bookingInformation.items, verifyTotal: this.bookingInformation.verifyTotal});
          
          // Second we create the contract for the fresh generated bookingId
          const newContract = await this.$store.dispatch("contracts/create", {...this.formData, rentObjectBookingId: newBooking.id, sendEmail});
          contractId = newContract.id;

          // Third we send the user to the new created booking
          this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(newBooking.startDate).toHTTP(), jumpObjectId: newBooking.rentObjectId}});
        } else if (this.updatePreviewMode) {
          // First we create the booking
          await this.$store.dispatch("rentObjectBookings/update", {...this.booking, ...this.bookingInformation.items, verifyTotal: this.bookingInformation.verifyTotal});
          
          // Second we create the contract for the fresh generated bookingId
          const newContract = await this.$store.dispatch("contracts/create", {...this.formData, rentObjectBookingId: this.booking.id, sendEmail});
          contractId = newContract.id;

          // Third we send the user to the new created booking
          this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.booking.startDate).toHTTP(), jumpObjectId: this.booking.rentObjectId}});
        } else {
          const newContract = await this.$store.dispatch("contracts/create", {...this.formData, rentObjectBookingId: this.fullBooking.id, sendEmail});
          contractId = newContract.id;

          this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.booking.startDate).toHTTP(), jumpObjectId: this.booking.rentObjectId}});
          this.$emit('refreshInbox');
        }

        if (contractId) {
          const newFile = await this.$store.dispatch('contracts/getAttachement', {id: contractId});
          const file = new Blob([newFile], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }

        this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
        this.$emit('updateBookingData', this.fullBooking);
        loadingComponent.close();
        this.$emit('close');
      });
    },
    calcTotalPrices(booking) {
      const prices = {
        totalRentPrice: 0,
        totalItemPrice: 0
      }

      if (booking.priceItems) {
        for (let i = 0; i < booking.priceItems.length; i += 1) {
          prices.totalRentPrice += booking.priceItems[i].totalPrice;
        }
        for (let i = 0; i < booking.bookingExtraItems.length; i += 1) {
          prices.totalItemPrice += booking.bookingExtraItems[i].totalPrice;
        }
      } else if (booking.bookingItems) {
        for (let i = 0; i < booking.bookingItems.length; i += 1) {
          if (booking.bookingItems[i].referenceColumnName === 'rentObjectPrices') {
            prices.totalRentPrice += booking.bookingItems[i].totalPrice;
          }
          if (booking.bookingItems[i].referenceColumnName === 'rentObjectBookingExtras') {
            prices.totalItemPrice += booking.bookingItems[i].totalPrice;
          }
        }
      }

      return prices;
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}
</style>